import api from '../api';

export const verificationService = {
  /**
   * Initiate credential verification
   */
  async verifyCredential(data) {
    const response = await api.post('/verification/verify', data);
    return response.data;
  },

  /**
   * Get all verifications for a provider
   */
  async getVerificationStatus(providerId) {
    const response = await api.get(`/verification/provider/${providerId}`);
    return response.data;
  },

  /**
   * Retry a failed verification
   */
  async retryVerification(verificationId) {
    const response = await api.post(`/verification/retry/${verificationId}`, {});
    return response.data;
  },

  /**
   * Get expiring credentials (admin only)
   */
  async getExpiringCredentials(days) {
    const response = await api.get(`/verification/expiring/${days}`);
    return response.data;
  },

  /**
   * Get verification evidence/document
   */
  async getVerificationEvidence(verificationId) {
    const response = await api.get(`/verification/status/${verificationId}`);
    return response.data;
  },

  /**
   * Get vault document for preview
   */
  async getVaultDocument(documentId) {
    const response = await api.get(`/credentialing/vault/${documentId}/download`, {
      responseType: 'blob'
    });
    return response;
  },

  /**
   * Get all vault documents for current user
   */
  async getVaultDocuments() {
    const response = await api.get('/credentialing/vault');
    return response.data;
  },

  /**
   * Queue NBCRNA verification for a provider
   */
  async queueNbcrnaVerification(data) {
    const response = await api.post('/nbcrna-verification/queue', data);
    return response.data;
  },
};

export default verificationService;
